<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="firewallRules"
      :items="firewallRules"
      :fields="firewallRulesFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedFirewallRules"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      firewallRulesFields: [
        {key: 'rule_id', label: 'ID', sortable: true},
        {key: 'allUsers', label: this.$i18n.t('All users'), sortable: true},
        {key: 'user_id', label: this.$i18n.t('User ID'), sortable: true},
        {key: 'group_id', label: this.$i18n.t('Group ID'), sortable: true},
        {key: 'tariff_id', label: this.$i18n.t('Tariff ID'), sortable: true},
        {key: 'affector_id', label: this.$i18n.t('Firewall'), sortable: true},
        {key: 'allParam', label: this.$i18n.t('All parameters match'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'text', label: this.$i18n.t('Rule'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedFirewallRules: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      urlParamMarker: 'THERE_ARE_URL_PARAMS!'
    }
  },
  methods: {
    showAdd () {
      this.selectedFirewallRules = {
        events: 0,
        rule_id: 0,
        text: '',
        comment: '',
        affector_id: 0,
        group_id: 0,
        user_id: 0,
        tariff_id: 0,
        curEvent: 1,
        allParam: false,
        allUsers: false,
        isUrlParam: false
      }
      this.$root.$emit('bv::show::modal', 'modalEditFirewallRulesSetting', '#btnShow')
    },
    editItem (item) {
      item.curEvent = 1
      this.selectedFirewallRules = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditFirewallRulesSetting', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Firewall rules"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_FIREWALL_RULES', item.rule_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_FIREWALL_RULES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    firewallRules () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/FIREWALL_RULES']))
      for (let el of copy) {
        if (el.flags === 1) {
          el.allUsers = true
          el.allParam = false
        } else if (el.flags === 2) {
          el.allUsers = false
          el.allParam = true
        } else {
          el.allUsers = false
          el.allParam = false
        }
        el.isUrlParam = false
        if (el.affector_type === 2 &&
        (el.text.search(this.urlParamMarker) !== -1)) {
          el.text = el.text.substr(this.urlParamMarker.length)
          el.isUrlParam = true
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_FIREWALL_RULES')
    this.$store.dispatch('Settings/GET_FIREWALLS')
    this.$store.dispatch('Tariffing/GET_TARIFFS')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Settings/GET_FW_EVENT_MASKS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/firewallRules/main.vue